import { InputLabel, Stack, Typography } from "@mui/material";
import React from "react";

export interface ViewEditInputProps {
  isEditing: boolean;
  children: React.ReactNode;
  label?: string;
  value?: string;
  style?: React.CSSProperties;
  startAdornment?: JSX.Element;
}

export const ViewEditInput = (props: ViewEditInputProps) => {
  if (props.isEditing) return props.children;

  let childProps: { label?: string; value?: string } = {
    label: props.label,
    value: props.value,
  };

  // Loop through children and access their props
  React.Children.forEach(props.children, (child) => {
    if (React.isValidElement(child)) {
      // Type assertion to get the child's props safely
      childProps = child.props as { label: string; value: string };
    }
  });

  return (
    <Stack
      direction="column"
      sx={{ height: "40px", marginLeft: "14px", ...props.style }}
    >
      <InputLabel htmlFor="view-edit-value" sx={{ fontSize: "12px" }}>
        {childProps.label ?? props.label}
      </InputLabel>
      <Stack direction="row" spacing="10px">
        {props.startAdornment}
        <Typography id="view-edit-value" variant="body1" noWrap>
          {childProps.value
            ? childProps.value
            : props.value
            ? props.value
            : "-"}
        </Typography>
      </Stack>
    </Stack>
  );
};
